import React, { Component } from 'react'
import PropTypes from 'prop-types'
import SideListComponent from './SideListComponent'
import HomeTabsComponent from './HomeTabsComponent'
import { withRouter } from 'react-router'
import Hidden from '@material-ui/core/Hidden'
import Grid from '@material-ui/core/Grid'
import { withStyles } from '@material-ui/core/styles'
const styles = theme => ({
  container: {
    position: 'relative',
    overflow: 'hidden',
    paddingBottom: 8
  }
})
const propTypes = {
  classes: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  tables: PropTypes.array.isRequired,
  bars: PropTypes.array.isRequired,
  sidedTransactions: PropTypes.array.isRequired,
  playTransaction: PropTypes.func.isRequired,
  pauseTransaction: PropTypes.func.isRequired,
  removeSideTable: PropTypes.func.isRequired,
  prepareForPayment: PropTypes.func.isRequired,
  addSideTable: PropTypes.func.isRequired,
  createBar: PropTypes.func.isRequired,
  currentPricing: PropTypes.object.isRequired,
  map: PropTypes.object.isRequired
}

class HomeComponent extends Component {
  render() {
    const { classes, tables, bars, sidedTransactions, map, match } = this.props
    let tabId = (match.params || {}).tabId
    tabId =
      tabId && (Number(tabId) > 0 && Number(tabId) < 2) ? Number(tabId) : 0
    return (
      <Grid
        className={classes.container}
        item
        container
        direction="row"
        alignItems="stretch"
        justify="flex-start">
        <Grid
          item
          xs={12}
          sm={12}
          md={
            sidedTransactions.length === 0
              ? 12
              : sidedTransactions.length < 4
                ? 9
                : 8
          }
          lg={
            sidedTransactions.length === 0
              ? 12
              : sidedTransactions.length < 4
                ? 9
                : 7
          }
          xl={9}>
          <HomeTabsComponent
            tables={tables}
            tabId={tabId}
            bars={bars}
            currentPricing={this.props.currentPricing}
            map={map}
            createBar={this.props.createBar}
            addSideTable={this.props.addSideTable}
          />
        </Grid>
        {sidedTransactions.length === 0 ? null : (
          <Hidden smDown>
            <Grid
              item
              xs={12}
              sm={12}
              md={sidedTransactions.length < 4 ? 3 : 4}
              lg={sidedTransactions.length < 4 ? 3 : 5}
              xl={3}>
              <SideListComponent
                transactions={sidedTransactions}
                playTransaction={this.props.playTransaction}
                pauseTransaction={this.props.pauseTransaction}
                removeSideTable={this.props.removeSideTable}
                prepareForPayment={this.props.prepareForPayment}
              />
            </Grid>
          </Hidden>
        )}
      </Grid>
    )
  }
}

HomeComponent.propTypes = propTypes
export default withRouter(withStyles(styles)(HomeComponent))



// WEBPACK FOOTER //
// ./src/routes/Home/components/HomeComponent.js